<template>
  <div class="dashboard-block my-artist">
    <div class="dashboard-block__heading">
      <h3 class="dashboard-block__title c-with-icon">
        <svg
          class="icon-my_artist svg-icon"
          viewBox="0 0 19.98 25">
          <path
            class="color1"
            d="M16.08,25.5h-.35a.49.49,0,0,1-.49-.46l0-.35V19.22a.5.5,0,0,1,
            .5-.5h0a.5.5,0,0,1,.5.5V24.5c1.31,0,2.77-.69,2.77-2.4V19.18a5.07,
            5.07,0,0,0-5.07-5.07h-.28L10.34,17.3a.5.5,0,0,1-.7,0L6.35,
            14.11H6.08A5.08,5.08,0,0,0,1,19.18V22.1c0,1.69,1.45,2.34,2.77,
            2.4V19.22a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V25a.5.5,0,0,1-.5.5H4c-2.38,
            0-4-1.37-4-3.4V19.18a6.08,6.08,0,0,1,6.08-6.07h.47a.5.5,0,0,1,
            .35.14l3.09,3,3.09-3a.52.52,0,0,1,.35-.14h.48A6.07,6.07,0,0,1,20,
            19.18V22.1C20,24.13,18.41,25.5,16.08,25.5ZM10,1A4.68,4.68,0,0,0,
            4.92,6c0,3.38,2.28,6.13,5.07,6.13S15.06,9.4,15.06,6A4.68,4.68,0,0,
            0,10,1m0-1a5.66,5.66,0,0,1,6.07,6c0,3.93-2.72,7.13-6.07,7.13S3.92,
            10,3.92,6A5.66,5.66,0,0,1,10,0Z" />
        </svg>
        マイアーティスト
      </h3>
      <router-link
        v-if="items.length > 0"
        :to="{ name: 'artist-index' }"
        class="dashboard-block__link">
        マイアーティスト一覧へ
      </router-link>
    </div>
    <div class="dashboard-block__inner">
      <div
        v-if="items.length > 0"
        class="artist-list">
        <a
          v-for="item in items"
          :key="item.id"
          class="artist-list__item"
          href="#">
          <router-link :to="{ name : 'artist-detail', params : { id: item.id } }">
            <div
              class="artist-list__pic"
              :style="`background-image: url(/images/${item.image_path})`"></div>
            <div class="artist-list__name">
              <span class="artist-list__name_text">
                {{ item.name }}
              </span>
              <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
            </div>
          </router-link>
        </a>
      </div>
      <div
        v-else
        class="artist-list">
        <p
          class="empty-artist"
          colspan="7">
          アーティストの登録はされていません。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardMyArtist',
  data() {
    return {
      items: [],
    }
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const count = 50
      const response = await window.axios.get(`/api/client/artists?type=1&count=${count}`)
      this.items = response.data.data
    },
  },
}
</script>

<style scoped>
.empty-artist {
  margin: auto;
  text-align: center;
  color: #505050;
  padding-top: 3vmin;
  padding-bottom: 3vmin;
}
</style>
